import styled from '@emotion/styled';

export const BreadcrumbsContainer = styled.div`
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  padding-right: 12px;
  display: flex;
  align-items: center;
  min-width: 200px;
`;
